
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"30","height":"30","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M11 24c0 1.935 1.789 3.5 4 3.5 2.211 0 4-1.565 4-3.5h-8zM15 5.188c3.45 0 6.25 2.8 6.25 6.25v8.75H8.75v-8.75c0-3.45 2.8-6.25 6.25-6.25z","fill":"#fff"}}),_c('path',{attrs:{"d":"M16.875 2.9a8.987 8.987 0 00-3.75 0C9.2 3.75 6.25 7.25 6.25 11.437v7.5l-2.5 2.5v1.25h22.5v-1.25l-2.5-2.5v-7.5c0-4.187-2.95-7.687-6.875-8.537z","fill":"#fff"}})])
          )
        }
      }
    